import { fetchSalesPlanningBarcodesData } from '../../Service/ApiService';
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const BarcodeScan90daysController = () => {
  const REPORTS_PAYLOAD_KEY = "samplePlanningReportsPayload90Days";
  const navigate = useNavigate();
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem('user'));
  const reportsPayload =
    location.state?.reportsPayload ||
    (() => {
      try {
        const raw = localStorage.getItem(REPORTS_PAYLOAD_KEY);
        return raw ? JSON.parse(raw) : {};
      } catch (e) {
        return {};
      }
    })();

  const [barcodeText, setBarcodeText] = React.useState('');
  const [barcodeError, setBarcodError] = React.useState('');
  const [barcodeData, setBarcodeData] = React.useState([]);

  // ✅ NEW — handle change similar to vendor side
  // const handleBarcodesChange = (e) => {
  //   let inputValue = e.target.value;

  //   // Append newline if not ending with comma or newline
  //   let processedValue = inputValue;
  //   if (!inputValue.endsWith(",") && !inputValue.endsWith("\n")) {
  //     processedValue += "\n";
  //   }

  //   processBarcodes(processedValue);
  // };

  const handleBarcodesChange = (e) => {
    let inputValue = e.target.value;

    // Scanner Enter behavior
    if (inputValue.endsWith("\n")) {
      inputValue = inputValue.trim();
      if (inputValue !== "") {
        inputValue += ",";
      }
      processBarcodes(inputValue);
      e.target.value = ""; // clear textarea (same as view 2)
      return;
    }

    setBarcodeText(inputValue);
  };


  // ✅ NEW — handle paste similar to vendor side
  // const handleBarcodesPaste = (e) => {
  //   e.preventDefault();

  //   const previousValue = e.target.value;
  //   const pastedText = e.clipboardData.getData("text");

  //   // Combine existing + pasted + comma
  //   const newValue = previousValue + pastedText + ",";
  //   setBarcodeText(newValue);
  //   processBarcodes(newValue);
  // };

  const handleBarcodesPaste = (e) => {
    e.preventDefault();

    const pastedText = e.clipboardData.getData("text");

    // Match View 2 formatting
    let formatted = pastedText
      .trim()
      .replace(/\s+/g, ",")
      .replace(/,+/g, ",");

    const combined = barcodeText
      ? `${barcodeText},${formatted}`
      : formatted;

    setBarcodeText(combined);
    processBarcodes(combined);
  };


  // ✅ NEW — unified processor for multiple barcodes
  // const processBarcodes = (inputValue) => {
  //   setBarcodeText(inputValue);

  //   let barcodesText = inputValue;
  //   const rawBarcodes = barcodesText
  //     .split(",")
  //     .map((b) => b.trim())
  //     .filter((b) => b !== "");

  //   // If there are valid barcodes, fetch their details
  //   if (rawBarcodes.length > 0) {
  //     // Join barcodes back into comma-separated string for API
  //     const finalBarcodes = rawBarcodes.join(",");
  //     getData(finalBarcodes);
  //   }

  //   // If the input ends with newline (Enter after scan)
  //   if (barcodesText.endsWith("\n")) {
  //     barcodesText = barcodesText.trim();
  //     if (barcodesText !== "") {
  //       barcodesText += ",";
  //     }
  //     setBarcodeText(barcodesText);
  //   }
  // };

  const processBarcodes = (inputValue) => {
    setBarcodeText(inputValue);

    let trimmed = inputValue.trim();
    if (trimmed.endsWith(",")) {
      trimmed = trimmed.slice(0, -1);
    }

    const barcodes = trimmed
      .split(",")
      .map(b => b.trim())
      .filter(Boolean);

    if (barcodes.length > 0) {
      // 🔑 API requires trailing comma
      getData(barcodes.join(",") + ",");
    }
  };


  // ✅ Your existing functions below remain unchanged
  const handleOkButtonClick = () => {
    if (barcodeText == '') {
      setBarcodError('Please enter barcode');
    } else {
      getData(barcodeText);
    }
  };

  const handleClearButtonClick = () => {
    setBarcodeText('');
    setBarcodError('');
  };

  const handleChange = (e) => {
    setBarcodeData([]);
    let inputValue = e.target.value;

    if (inputValue.endsWith('\n')) {
      console.log('its a barcode scan');

      inputValue = inputValue.trim();
      if (inputValue !== '') {
        inputValue += ',';
      }
      getData(inputValue);
      e.target.value = '';
    }

    inputValue = inputValue.trim();
    setBarcodeText(inputValue);
  };

  const getData = async (inputValue) => {
    try {
      const res = await fetchSalesPlanningBarcodesData(
        user.userId,
        '',
        user.userCode,
        user.userVerticalId,
        inputValue,
        ''
      );

      if (res && res.success == "true") {
        setBarcodeData(res.materialList);
      } else {
        setBarcodeData([]);
      }
    } catch (err) {
      console.error("User Sales Reports load error:", err);
    }
  };

  const handleTextareaResize = (event) => {
    const textarea = event.target;
    textarea.style.height = 'auto';
  };

  const handleRemoveBarcode = (barcode) => {
    const updatedData = barcodeData.filter((item) => item.barcode !== barcode);
    const parts = barcodeText
      .split(',')
      .map(p => p.trim())
      .filter(p => p.length > 0 && p !== barcode);
    setBarcodeText(parts.join(','));
    setBarcodeData(updatedData);
  };

  const handleProceed = () => {
    if (barcodeData.length === 0) {
      return;
    }
    navigate('/sample-selection-sales-planning', {
      state: {
        barcodeData: barcodeData,
        reportsPayload
      }
    });
  };

  return {
    barcodeText,
    barcodeData,
    barcodeError,
    handleOkButtonClick,
    handleClearButtonClick,
    handleChange,
    handleTextareaResize,
    handleRemoveBarcode,
    handleProceed,
    handleBarcodesChange,
    handleBarcodesPaste,
  };
};

export default BarcodeScan90daysController;
